import { MOKA_SERVICE_HOST, API_URL, MOKA_INVENTORY_API } from 'api/constants';

export const ADD_SUBSCRIPTION = `${API_URL}/v1/feature/add_subscription`;
export const UNION_CATEGORIES_AND_ITEMS = `${MOKA_INVENTORY_API}/v1/items/union_category_and_item_names`;
export const UNION_ITEM_VARIANTS = `${MOKA_INVENTORY_API}/v1/items/union_item_variants`;

export const GET_LOYALTY = () => `${MOKA_SERVICE_HOST}/loyalty/v3/programs`;
export const CREATE_LOYALTY = () => `${MOKA_SERVICE_HOST}/loyalty/v3/programs`;
export const EDIT_LOYALTY = programId =>
  `${MOKA_SERVICE_HOST}/loyalty/v3/programs/${programId}`;
export const RESET_LOYALTY = programId =>
  `${MOKA_SERVICE_HOST}/loyalty/v3/programs/${programId}/reset`;
export const REACTIVATE_LOYALTY = programId =>
  `${MOKA_SERVICE_HOST}/loyalty/v3/programs/${programId}/reactivate`;
export const DEACTIVATE_LOYALTY = programId =>
  `${MOKA_SERVICE_HOST}/loyalty/v3/programs/${programId}/deactivate`;
